import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { CONSENT_PROPERTY_API } from "./apiRoutes";

interface getProps {
  communityId: string;
  propertyId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">
}

const getNeighborProperties = async (communityId: string, propertyId: string) =>
  await axiosAuth.get(`${CONSENT_PROPERTY_API(communityId, propertyId)}/consent/neighbor-options`);

const useGetNeighborProperties = ({
  communityId,
  propertyId,
  queryParams
}: getProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["neighbor-properties", communityId],
    queryFn: () => getNeighborProperties(communityId, propertyId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && !!propertyId && (queryParams?.enabled ?? true),
  });
};

export default useGetNeighborProperties;
